import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import LoginPage from './pages/login/LoginPage';
import RedirectPage from './pages/RedirectPage';
import ImagesPage from './pages/images/ImagesPage';
import DomainsPage from './pages/domains/DomainsPage';
import QualityControlPage from './pages/qualityControlPage/QualityControlPage';
import FinalReviewPage from './pages/finalReviewPage/FinalReviewPage';
import SearchPage from './pages/search/SearchPage';
import ImportPage from './pages/import/ImportPage';
import AdminPage from './pages/admin/AdminPage';
import ImageManagementPage from './pages/imageManagement/ImageManagementPage';
import UploadOriginalImagesPage from './pages/upload/UploadOriginalImagesPage';
import { NotFound } from './pages/error/404/NotFound';
import { NotAuthorized } from './pages/error/403/NotAuthorized';
import SocialMediaQualityPage from './pages/socialMediaQualityPage/SocialMediaQualityPage';
import DomainManagementPage from './pages/domainManagement/DomainManagementPage';
import TargetManagementPage from './pages/targetManagementPage/TargetManagementPage';
import BlacklistedPatternPage from './pages/blacklistedPattern/BlacklistedPatternPage';

export const PublicRoutes = () => (
  <Switch>
    <Route path='/login' component={LoginPage} />
    <Redirect to='/login' />
  </Switch>
);

export const AuthenticatedRoutes = (adminRole) => (
  <Switch>
    <Route exact path='/login' render={() => <Redirect to='/' />} />
    {adminRole ? (
      <Route exact path='/' render={() => <Redirect to='/quality_control' />} />
    ) : (
      <Route exact path='/' render={() => <Redirect to='/redirect' />} />
    )}
    <Route exact path='/redirect' component={RedirectPage} />
    <Route exact path='/images' component={ImagesPage} />
    <Route exact path='/domains' component={DomainsPage} />
    <Route exact path='/quality_control' component={QualityControlPage} />
    <Route
      exact
      path='/social_media_quality_control'
      component={SocialMediaQualityPage}
    />
    <Route exact path='/final_review' component={FinalReviewPage} />
    <Route exact path='/search' component={SearchPage} />
    <Route exact path='/search/usage_url' component={SearchPage} />
    <Route exact path='/search/clickhouse_usage_url' component={SearchPage} />
    <Route exact path='/import' component={ImportPage} />
    <Route exact path='/image-management' component={ImageManagementPage} />
    <Route exact path='/domain-management' component={DomainManagementPage} />
    <Route exact path='/target-management' component={TargetManagementPage} />
    <Route exact path='/upload-original' component={UploadOriginalImagesPage} />
    <Route
      exact
      path='/blacklisted-pattern'
      component={BlacklistedPatternPage}
    />
    {adminRole && <Route exact path='/admin-panel' component={AdminPage} />}
    <Route exact path='/403' component={NotAuthorized} />
    <Route component={NotFound} />
  </Switch>
);
